import dayjs from 'dayjs';
import dayjsUtc from 'dayjs/plugin/utc';
import dayjsDuration from 'dayjs/plugin/duration';
import { TranslateFunc } from '@ha/intl';

dayjs.extend(dayjsDuration);
dayjs.extend(dayjsUtc);

export function getLastActivityHumanized(
  T: TranslateFunc,
  lastActivity: string,
) {
  const duration = dayjs.duration(dayjs().diff(dayjs.utc(lastActivity)));
  const hours = Math.floor(duration.asHours());

  if (hours < 1) {
    return T('Last seen few minutes ago');
  }

  if (hours < 2) {
    return T('Last seen 1 hour ago');
  }

  if (hours < 24) {
    return T('Last seen %d hours ago', hours);
  }

  const days = Math.floor(duration.asDays());

  if (days < 2) {
    return T('Last seen 1 day ago');
  }

  if (days < 7) {
    return T('Last seen %d days ago', days);
  }

  const weeks = Math.floor(duration.asWeeks());
  const edgeValue = 2;

  if (weeks < 2) {
    return T('Last seen a week ago');
  }

  if (weeks <= edgeValue) {
    return T('Last seen %d weeks ago', weeks);
  }

  return T('Last seen more than %d weeks ago', edgeValue);
}
